import { createVanIconComponent } from "./van"

const Audio = createVanIconComponent("audio")
export default Audio
